<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <h4 class="fs-18 fw-semibold mb-0">
          Liste des demandes d'emprunt
          <span v-if="demandesEnAttente > 0" class="badge bg-warning text-dark ms-2">
            {{ demandesEnAttente }} en attente
          </span>
        </h4>
      </div>
      <div class="d-sm-flex align-items-center">
        <div class="d-flex gap-2">
          <select class="form-select" v-model="filtreStatut" @change="rechercher" style="min-width: 150px;">
            <option value="">Tous les statuts</option>
            <option value="en attente">En attente</option>
            <option value="approuvée">Approuvées</option>
            <option value="rejetée">Rejetées</option>
            <option value="en cours">En cours</option>
            <option value="terminée">Terminées</option>
          </select>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="searchTerm"
              @keyup.enter="rechercher"
              placeholder="Rechercher par titre, demandeur..."
            >
            <button class="btn btn-primary" type="button" @click="rechercher">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
               <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Document demandé
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date Debut
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date Fin
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Motif demande
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Demandeur
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date demande
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Statut
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0  pe-0">
                ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(document, index) in documents" :key="index">
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ document?.documentTitre }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_Date(document.dateDebut) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_Date(document.dateFin) }}
              </td>
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ document?.motif }}
              </td>
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ document?.user?.nom }} {{ document?.user?.prenoms }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_Date(document.createdAt) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span :class="getStatutBadgeClass(document?.statut)" class="badge fs-12 fw-medium">
                  {{ document?.statut }}
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary pe-0">
                <div class="dropdown">
                    <span
                      class="badge text-white bg-primary fs-15 dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li v-if="document?.statut?.toLowerCase() === 'en attente' || document?.statut?.toLowerCase() === 'attente'">
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="traiterDemande(document)">
                        <i class="fa fa-edit lh-1 me-8 position-relative top-1" v-if="checkPermission('ViewEmprunt')"></i>
                        Traiter demande
                      </a>
                    </li>
                    <li v-if="checkPermission('ViewEmprunt')">
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="voirDetails(document)">
                        <i class="fa fa-eye lh-1 me-8 position-relative top-1"></i>
                        Détails demande
                      </a>
                    </li>
                    <li v-if="checkPermission('DeleteEmprunt')">
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="suppression(document.id, documents, 'documents', `Demande ${document.id}`)">
                        <i class="fa fa-trash-o lh-1 me-8 position-relative top-1"></i>
                        Supprimer demande
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>

  <!-- Modal pour les détails de la demande -->
  <div ref="modalRef" class="modal fade" id="detailsDemandeModal" tabindex="-1" aria-labelledby="detailsDemandeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="detailsDemandeModalLabel">
            <i class="fa fa-info-circle me-2"></i>
            Détails de la demande d'emprunt
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="fermerModal"></button>
        </div>
        <div class="modal-body">
          <div v-if="selectedDemande">
            <!-- Informations sur la demande -->
            <div class="card mb-3">
              <div class="card-header bg-primary text-white" >
                <h6 class="mb-0 text-white">
                  <i class="fa fa-book me-2"></i>
                  Informations sur la demande
                </h6>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <p class="mb-2"><strong>Document demandé :</strong></p>
                    <p class="text-muted">{{ selectedDemande.documentTitre || 'Non spécifié' }}</p>
                  </div>
                  <div class="col-md-4">
                    <p class="mb-2"><strong>Date de demande :</strong></p>
                    <p class="text-muted">{{ format_Date(selectedDemande.createdAt) }}</p>
                  </div>
                   <div class="col-md-4">
                    <p class="mb-2"><strong>Statut :</strong></p>
                    <span :class="getStatutBadgeClass(selectedDemande.statut)" class="badge fs-14 fw-medium">
                      {{ selectedDemande.statut }}
                    </span>
                  </div>
                   <div class="col-md-4">
                    <p class="mb-2"><strong>Date de début :</strong></p>
                    <p class="text-muted">{{ format_Date(selectedDemande.dateDebut) }}</p>
                  </div>
                  <div class="col-md-4">
                    <p class="mb-2"><strong>Date de fin :</strong></p>
                    <p class="text-muted">{{ format_Date(selectedDemande.dateFin) }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <p class="mb-2"><strong>Motif de la demande :</strong></p>
                    <p class="text-muted p-2 bg-light rounded">{{ selectedDemande.motif || 'Aucun motif spécifié' }}</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Informations du demandeur -->
            <div class="card mb-3">
              <div class="card-header bg-info text-white">
                <h6 class="mb-0">
                  <i class="fa fa-user me-2"></i>
                  Informations du demandeur
                </h6>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <p class="mb-2"><strong>Nom complet :</strong></p>
                    <p class="text-muted">{{ selectedDemande.user?.nom || '' }} {{ selectedDemande.user?.prenoms || '' }}</p>
                  </div>
                  <div class="col-md-6">
                    <p class="mb-2"><strong>Email :</strong></p>
                    <p class="text-muted">{{ selectedDemande.user?.email || 'Non spécifié' }}</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Statut et période -->
            

            <!-- Motif de traitement (si disponible) -->
            <div v-if="motifTraitement" class="card mb-3">
              <div class="card-header bg-warning text-dark">
                <h6 class="mb-0">
                  <i class="fa fa-comment me-2"></i>
                  Motif de traitement
                </h6>
              </div>
              <div class="card-body">
                <p class="mb-0 p-2 bg-light rounded fst-italic">{{ motifTraitement }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="fermerModal">
            <i class="fa fa-times me-2"></i>
            Fermer
          </button>
          <button 
            v-if="selectedDemande && (selectedDemande.statut?.toLowerCase() === 'en attente' || selectedDemande.statut?.toLowerCase() === 'attente')"
            type="button" 
            class="btn btn-primary" 
            @click="traiterDemandeFromModal"
          >
            <i class="fa fa-edit me-2"></i>
            Traiter la demande
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref, computed } from "vue";
import Swal from "sweetalert2";
import ApiService from "@/services/ApiService";
import { format_date, format_Date, suppression, error } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import { Emprunt } from "@/models/Emprunt";

export default defineComponent({
  name: "ListeDocument",
  components: {
    PaginationComponent
  },
  setup() {

    // Gestionnaire pour la touche Escape
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && selectedDemande.value) {
        fermerModal();
      }
    };

    onMounted(() => {
      getAllDemandes();
      
      // Ajouter event listener pour la touche Escape
      window.document.addEventListener('keydown', handleEscape);
    });
    
    onUnmounted(() => {
      // Cleanup des event listeners
      window.document.removeEventListener('keydown', handleEscape);
    });

    const documents = ref<Array<Emprunt>>([]);
    const document = ref<Emprunt>();
    const selectedDemande = ref<Emprunt | null>(null);
    const modalRef = ref<HTMLElement | null>(null);

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const filtreStatut = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllDemandes(page_, limit_, searchTerm.value, filtreStatut.value);
      } catch (error) {
        //
      }
    };

    function rechercher() {
      page.value = 1; // Reset à la première page lors d'une recherche
      getAllDemandes(page.value, limit.value, searchTerm.value, filtreStatut.value);
    }


    // END PAGINATE

    function getAllDemandes(page = 1, limi = 10, searchTerm = '', statutFilter = '') {
      let url = `/all/emprunts?page=${page}&limit=${limi}&mot=${searchTerm}`;
      if (statutFilter) {
        url += `&statut=${encodeURIComponent(statutFilter)}`;
      }
      
      return ApiService.get(url)
        .then(({ data }) => {
          documents.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
        });

    }

    function moddifier(EditDocument: Emprunt) {
      document.value = EditDocument;
    }

    function traiterDemande(demande: Emprunt) {
      Swal.fire({
        title: 'Traitement de la demande',
        html: `
          <div class="text-center mb-3">
            <p><strong>Document :</strong> ${demande.documentTitre}, 
            <strong>Demandeur :</strong> ${demande.user?.nom || ''} ${demande.user?.prenoms || ''}</p>
          </div>
          <div class="mb-3">
            <label for="motifTraitement" class="form-label text-start">Motif du traitement (optionnel):</label>
            <textarea 
              id="motifTraitement" 
              class="form-control" 
              rows="3" 
              placeholder="Saisissez un motif pour approuver ou rejeter cette demande..."
            ></textarea>
          </div>
        `,
        icon: 'question',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'Approuver',
        denyButtonText: 'Rejeter',
        cancelButtonText: 'Annuler',
        customClass: {
          confirmButton: "btn fw-semobold btn-success me-2",
          denyButton: "btn fw-semobold btn-danger me-2",
          cancelButton: "btn fw-semobold btn-secondary",
        },
        buttonsStyling: false,
        heightAuto: false,
        preConfirm: () => {
          const motif = (window.document.getElementById('motifTraitement') as HTMLTextAreaElement)?.value || '';
          return { motif };
        }
      }).then((result) => {
        if (result.isConfirmed) {
          // Approuver la demande
          traiterDemandeApi(demande.id, 'Approuvée', result.value.motif);
        } else if (result.isDenied) {
          // Pour le rejet, récupérer le motif depuis la modal fermée
          traiterDemandeApi(demande.id, 'Rejetée', result.value.motif);
          // Swal.fire({
          //   title: 'Confirmer le rejet',
          //   html: `
          //     <div class="text-start mb-3">
          //       <p class="text-danger"><strong>Vous êtes sur le point de rejeter cette demande.</strong></p>
          //       <p><strong>Document :</strong> ${demande.documentTitre}</p>
          //     </div>
          //     <div class="mb-3">
          //       <label for="motifRejet" class="form-label">Motif du rejet (recommandé):</label>
          //       <textarea 
          //         id="motifRejet" 
          //         class="form-control" 
          //         rows="3" 
          //         placeholder="Veuillez expliquer la raison du rejet..."
          //       ></textarea>
          //     </div>
          //   `,
          //   icon: 'warning',
          //   showCancelButton: true,
          //   confirmButtonText: 'Confirmer le rejet',
          //   cancelButtonText: 'Annuler',
          //   customClass: {
          //     confirmButton: "btn fw-semobold btn-danger",
          //     cancelButton: "btn fw-semobold btn-secondary",
          //   },
          //   buttonsStyling: false,
          //   heightAuto: false,
          //   preConfirm: () => {
          //     const motif = (window.document.getElementById('motifRejet') as HTMLTextAreaElement)?.value || '';
          //     return { motif };
          //   }
          // }).then((rejetResult) => {
          //   if (rejetResult.isConfirmed) {
          //     traiterDemandeApi(demande.id, 'Rejetée', rejetResult.value.motif);
          //   }
          // });
        }
      });
    }

    function traiterDemandeApi(demandeId: number, statut: string, motif = '') {
      const payload = { 
        statut: statut,
        ...(motif && { motif: motif })
      };
      
      ApiService.put(`/emprunts/${demandeId}/traiter`, payload)
        .then(({ data }) => {
          Swal.fire({
            text: data.message || `Demande ${statut} avec succès`,
            toast: true,
            icon: 'success',
            title: 'Traitement réussi',
            animation: false,
            position: 'top-right',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            heightAuto: false
          });
          // Recharger la liste
          getAllDemandes(page.value, limit.value, searchTerm.value, filtreStatut.value);
        })
        .catch(({ response }) => {
          error(response?.data?.message || 'Erreur lors du traitement de la demande');
        });
    }

    const deleteDocument = (id: number) => {
      ApiService.delete(`/emprunts/${id}`)
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            toast: true,
            icon: 'success',
            title: 'General Title',
            animation: false,
            position: 'top-right',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            heightAuto: false
          });
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Réssayer à nouveau!",
            heightAuto: false,
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });

      for (let i = 0; i < documents.value.length; i++) {
        if (documents.value[i].id === id) {
          documents.value.splice(i, 1);
        }
      }
    };

    function voirDetails(demande: Emprunt) {
      selectedDemande.value = demande;
      
      // Utiliser setTimeout pour s'assurer que selectedDemande est mis à jour
      setTimeout(() => {
        const modalElement = modalRef.value || window.document.getElementById('detailsDemandeModal');
        if (modalElement) {
          try {
            // Essayer d'abord avec Bootstrap 5
            if ((window as any).bootstrap?.Modal) {
              const modal = new (window as any).bootstrap.Modal(modalElement);
              modal.show();
            } 
            // Essayer avec jQuery Bootstrap (version 4 ou antérieure)
            else if ((window as any).$ && (window as any).$().modal) {
              ((window as any).$(modalElement) as any).modal('show');
            } 
            // Manipulation CSS directe en dernier recours
            else {
              showModalManually(modalElement);
            }
          } catch (error) {
            console.warn('Erreur avec Bootstrap Modal, utilisation de la méthode manuelle:', error);
            showModalManually(modalElement);
          }
        }
      }, 50);
    }
    
    function showModalManually(modalElement: HTMLElement) {
      modalElement.classList.add('show');
      modalElement.style.display = 'block';
      modalElement.setAttribute('aria-hidden', 'false');
      window.document.body.classList.add('modal-open');
      
      // Ajouter backdrop si pas déjà présent
      if (!window.document.querySelector('.modal-backdrop')) {
        const backdrop = window.document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        backdrop.id = 'modal-backdrop-custom';
        window.document.body.appendChild(backdrop);
        
        // Ajouter event listener pour fermer sur click backdrop
        backdrop.addEventListener('click', fermerModal);
      }
    }

    function traiterDemandeFromModal() {
      if (selectedDemande.value) {
        // Fermer le modal de détails
        fermerModal();
        // Ouvrir le modal de traitement
        traiterDemande(selectedDemande.value);
      }
    }

    function fermerModal() {
      const modalElement = modalRef.value || window.document.getElementById('detailsDemandeModal');
      if (modalElement) {
        try {
          // Essayer avec Bootstrap 5
          if ((window as any).bootstrap?.Modal) {
            const modal = (window as any).bootstrap.Modal.getInstance(modalElement);
            if (modal) {
              modal.hide();
            } else {
              hideModalManually(modalElement);
            }
          } 
          // Essayer avec jQuery
          else if ((window as any).$ && (window as any).$().modal) {
            ((window as any).$(modalElement) as any).modal('hide');
          } 
          // Méthode manuelle
          else {
            hideModalManually(modalElement);
          }
        } catch (error) {
          console.warn('Erreur lors de la fermeture du modal:', error);
          hideModalManually(modalElement);
        }
      }
    }
    
    function hideModalManually(modalElement: HTMLElement) {
      modalElement.classList.remove('show');
      modalElement.style.display = 'none';
      modalElement.setAttribute('aria-hidden', 'true');
      window.document.body.classList.remove('modal-open');
      
      // Supprimer backdrop
      const backdrop = window.document.getElementById('modal-backdrop-custom') || 
                      window.document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
      
      // Réinitialiser selectedDemande
      //selectedDemande.value = null;
    }

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    const getStatutBadgeClass = (statut: string) => {
      switch (statut?.toLowerCase()) {
        case 'en attente':
        case 'attente':
          return 'bg-warning text-dark';
        case 'approuvée':
        case 'approuve':
        case 'acceptée':
          return 'bg-success text-white';
        case 'rejetée':
        case 'rejete':
        case 'refusée':
          return 'bg-danger text-white';
        case 'en cours':
        case 'cours':
          return 'bg-info text-white';
        case 'terminée':
        case 'termine':
        case 'retournée':
          return 'bg-secondary text-white';
        default:
          return 'bg-light text-dark';
      }
    }

    const demandesEnAttente = computed(() => {
      return documents.value.filter(doc => 
        doc.statut?.toLowerCase() === 'en attente' || doc.statut?.toLowerCase() === 'attente'
      ).length;
    });

    const motifTraitement = computed(() => {
      return selectedDemande.value ? (selectedDemande.value as any)?.motifTraitement : null;
    });

    return {
      documents,
      selectedDemande,
      modalRef,
      checkPermission,
      getAllDemandes,
      format_date,
      deleteDocument,
      moddifier,
      traiterDemande,
      voirDetails,
      traiterDemandeFromModal,
      fermerModal,
      showModalManually,
      hideModalManually,
      getStatutBadgeClass,
      demandesEnAttente,
      motifTraitement,
      suppression,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
      filtreStatut,
      format_Date,
    };
  },
});
</script>

<style scoped>
.modal-dialog {
  max-width: 900px;
}

.card-header {
  border-bottom: 1px solid rgba(0,0,0,.125);
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
}

.badge.fs-14 {
  font-size: 0.875rem !important;
  padding: 0.5rem 1rem;
}

.card {
  border: 1px solid rgba(0,0,0,.125);
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.card-header h6 {
  margin: 0;
  font-weight: 600;
}

.text-muted {
  color: #6c757d !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}
</style>